import React,{useEffect, useState} from 'react'
import Dots from '../SlideShow/Dots'
import ImageSlider from '../SlideShow/ImageSlider'
import {imageSlider} from '../SlideShow/Imagesdata';
import DropMain from '../DropDown/DropMain';
import "./header.css"
import Products from './Products';

const len = imageSlider.length -1;

function Header() {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() =>{
    const interval = setInterval(() => {
      setActiveIndex(activeIndex === len ? 0 : activeIndex + 1)
    },3000)
    return () => clearInterval(interval)
  }, [activeIndex])

  const slideContainer ={
    maxWidth:"100%",
    height : "350px",
    margin: "0", 
  }

    return (
    <div>
        <div style={slideContainer}>
          <ImageSlider activeIndex={activeIndex} imageSlider={imageSlider} />
          <Dots  activeIndex={activeIndex} 
                  imageSlider={imageSlider} 
                  onClick={activeIndex =>setActiveIndex(activeIndex)}
          />
        </div>
        <div className='drop--menu'>
          <DropMain />  
        </div>
        <div>
          <Products />
        </div>
        
    </div>
  )
}

export default Header